// extracted by mini-css-extract-plugin
module.exports = {"musicProgress":"music-progress-bar_musicProgress__2OXEW"};